import api from '../utils/api';

// Liste de toutes les catégories
export const getAllCategories = async () => {
    try {
        const response = await api.get('/categories');
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch categories');
    }
};

// Recherche pour l'autocomplétion : /categories/search?q=...
export const searchCategories = async (q) => {
    try {
        const response = await api.get('/categories/search', { params: { q } });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to search categories');
    }
};

// Création d'une catégorie (nom + icône + couleur + description)
export const createCategory = async (data) => {
    try {
        const response = await api.post('/categories', data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to create category');
    }
};

export const updateCategory = async (id, data) => {
    try {
        const response = await api.put(`/categories/${id}`, data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to update category');
    }
};